import { api } from './_init'

export const fetchBackhaulEvaluation = async (packageId) => {
  try {
    const response = await api.get(`/package_builder/packages/${packageId}/backhaul_evaluation`)
    
    if (response.status === 200) {
      return {
        data: response.data,
        success: true,
        error: false,
      }
    } else {
      return {
        data: response.data,
        success: false,
        error: true,
      }
    }
  } catch (error) {
    return {
      data: null,
      success: false,
      error: true,
    }
  }
}